import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { GetPublicHolidays, CreateHoliday, EditHoliday, DeleteHoliday } from './HolidayAction';
import { FormControl, MenuItem, Select, Container, DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog, Grid, Button, TextField } from '@material-ui/core';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import OverLoader from '../../components/common/loader';
import '../../App.css';
import './system.css';
import { DatePicker } from 'antd';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import locale from 'antd/es/date-picker/locale/de_DE';
import Month from './monthList.json'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import 'moment/locale/de';
import Toolbar from 'react-big-calendar/lib/Toolbar';
import isEmpty from 'lodash.isempty';
import { LogoutAction } from '../../actions';


const localizer = momentLocalizer(moment)
const dateFormat = 'YYYY';

class PublicHoliday extends Component {

  constructor(props) {
    super(props);
    this.state = {
      holidayData: [],
      yearField: new Date().getFullYear(),
      monthField: new Date().getMonth() + 1,
      calanderDate: new Date(),
      holidayTitle: "",
      selectedDate: '',
      holidayId: '',
      holidayTitleError: false,
      editMode: false,
      isContentDialogOpen: false,
      isDeleteContactDialogOpen: false,
      error: '',
      accessErrorDialog: false
    }

    this.baseState = this.state;
    this.textInput = React.createRef();

  }

  focusTextInput = () => {
    this.textInput.current.focus();
  }

  componentDidMount = () => {
    const { GetPublicHolidays } = this.props
    GetPublicHolidays()
  }
  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { public_holidays, error_validation, access_error } = this.props
    if (nextProps.public_holidays !== public_holidays) {
      this.setState({
        holidayData: nextProps.public_holidays,
      })
    }
    if (nextProps.error_validation !== error_validation) {
      this.setState({ error: nextProps.error_validation })
    }
    if (nextProps.access_error !== access_error) {
      this.setState({ accessErrorDialog: true })
    }
  }

  deleteHoliday = () => {
    const { DeleteHoliday } = this.props
    const { holidayId } = this.state
    DeleteHoliday(holidayId)
    this.setState({ isContentDialogOpen: false, isDeleteContactDialogOpen: false, editMode: false, holidayTitle: '' })
  }

  addNewHoliday = () => {
    const { holidayTitle, selectedDate } = this.state
    const { CreateHoliday } = this.props;
    if (holidayTitle !== '') {
      CreateHoliday(selectedDate, holidayTitle)
      this.setState({ isContentDialogOpen: false, holidayTitle: '' })
    } else {
      this.setState({ holidayTitleError: true })
    }
  }

  dateSelected = (slot) => {
    const { holidayData } = this.state
    let startDate = slot.start
    let date = moment(startDate).format("YYYY-MM-DD");
    const cond = holidayData.every(item => {
      return (
        item.date !== date
      )
    })
    if (cond) {
      this.setState({ selectedDate: date, isContentDialogOpen: true })
    }
  }

  holidayChangeHandler = (e) => {
    this.setState({ holidayTitle: e.target.value, holidayTitleError: false })
  }

  holidaySelected = (e) => {
    let date = moment(e.date).format("YYYY-MM-DD");
    this.setState({ holidayId: e.id, holidayTitle: e.title, selectedDate: date, editMode: true, isContentDialogOpen: true })
  }

  editHoliday = () => {
    const { holidayTitle, selectedDate, holidayId } = this.state
    const { EditHoliday } = this.props
    if (holidayTitle !== '') {
      EditHoliday(holidayId, selectedDate, holidayTitle)
      this.setState({ isContentDialogOpen: false, editMode: false, holidayTitle: '' })
    } else {
      this.setState({ holidayTitleError: true })
    }
  }

  monthhandleChange = (e) => {
    const { yearField } = this.state
    let date = new Date(yearField, e.target.value - 1)
    this.setState({ monthField: e.target.value, calanderDate: date })
  }

  CalanderViewChange = (current) => {
    const { yearField, monthField } = this.state
    let date = new Date(yearField, monthField - 1)
    this.setState({ calanderDate: date })
    if (current) {
      let fullYear = new Date().getFullYear()
      let fullMonth = new Date().getMonth()
      let date = new Date(fullYear, fullMonth)
      this.setState({ calanderDate: date, yearField: fullYear, monthField: fullMonth + 1 })
    }
  }

  resetForm = () => {
    this.setState(this.baseState);
    setTimeout(() => {
      this.focusTextInput()
    }, 200)
  }

  openPopup = () => {
    this.setState({ isContentDialogOpen: true })
  }

  openDeleteDialogPopup = () => {
    this.setState({ isDeleteContactDialogOpen: true })
  }

  closeContentDialog = () => {
    this.setState({ isContentDialogOpen: false, editMode: false, holidayTitle: "", holidayTitleError: false })
  }
  closeDeleteContactDialog = () => {
    this.setState({ isDeleteContactDialogOpen: false })
  }
  onNavigate = (e) => {
    let date = new Date(e)
    this.setState({ calanderDate: date, monthField: date.getMonth() + 1, yearField: date.getFullYear() })
  }

  render() {
    const { calanderDate, accessErrorDialog, error, isDeleteContactDialogOpen, isContentDialogOpen, holidayTitle, holidayData, yearField, holidayTitleError, monthField, editMode } = this.state
    const { isloading, access_error } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div>
        {isloading && <OverLoader />}
        <Container maxWidth="md">
          <Grid container spacing={3} className="mainBlock">
            {isEmpty(error.message) ?
              <Grid item md={12} sm={12} xs={12}>
                <div className="rightBlock rightBlock-bgWhite ">
                  <div className="inner-field inner-field-1">
                    <label className="mb0">Jahr</label>
                    <div className="input-span">
                      <TextField type="number" size="small" value={yearField} className="innerInput rightToLeft" onChange={(e) => {
                        if (yearField.length < 4 || e.target.value.length < 4)
                          this.setState({ yearField: e.target.value.replace(/[^0-9]/g) })
                        setTimeout(() => {
                          this.CalanderViewChange()
                        }, 100)
                      }} variant="outlined" />
                      {/* <DatePicker
                      value={yearField === "" ? '' : moment(yearField, dateFormat)}
                      format={dateFormat}
                      allowClear={false}
                      bordered={false}
                      className="innerInput"
                      onChange={(e) => {
                        if (e !== null) {
                          let date = moment(e).format("YYYY");
                          this.setState({ yearField: date })
                          setTimeout(() => {
                            this.CalanderViewChange()
                          }, 100)
                        } else {
                          this.setState({ yearField: '' })
                        }
                      }}
                      picker="year" /> */}
                      <span>
                        <ArrowLeftIcon onClick={() => {
                          this.setState({ yearField: parseInt(yearField) - 1 })
                          setTimeout(() => {
                            this.CalanderViewChange()
                          }, 100)
                        }} />
                        <ArrowRightIcon className="ml" onClick={() => {
                          this.setState({ yearField: parseInt(yearField) + 1 })
                          setTimeout(() => {
                            this.CalanderViewChange()
                          }, 100)
                        }} />
                      </span>
                    </div>
                  </div>
                  <div className="inner-field inner-field-1">
                    <label className="mb0">Monat</label>
                    <div className="input-span">
                      <FormControl variant="outlined" style={{ minWidth: 120 }}>
                        <Select
                          value={monthField}
                          onChange={this.monthhandleChange}
                        >
                          {Month.map(item => {
                            return <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>

                          })}
                        </Select>
                      </FormControl>

                      <span>
                        <ArrowLeftIcon onClick={() => {
                          if (monthField > 1)
                            this.setState({ monthField: parseInt(monthField) - 1 })
                          setTimeout(() => {
                            this.CalanderViewChange()
                          }, 100)
                        }} />
                        <ArrowRightIcon className="ml" onClick={() => {
                          if (monthField < 12)
                            this.setState({ monthField: parseInt(monthField) + 1 })
                          setTimeout(() => {
                            this.CalanderViewChange()
                          }, 100)
                        }} />
                      </span>
                    </div>
                  </div>
                  <Button style={{ marginTop: "10px" }} onClick={() => {
                    this.CalanderViewChange(true)
                  }} variant="outlined" color="primary">
                    Dieser Monat
              </Button>
                  <Calendar
                    selectable
                    localizer={localizer}
                    events={holidayData}
                    messages={{ next: "Nächster", previous: "Bisherige", today: "Dieser Monat" }}
                    culture='de-DE'
                    components={{ toolbar: CustomToolbar }}
                    views={['month']}
                    style={Number(access_rights.public_holidays) === 1 ? { pointerEvents: "none", opacity: "0.6", height: 500 } : { height: 500 }}
                    onSelectSlot={slotInfo => this.dateSelected(slotInfo)}
                    onSelectEvent={(e) => this.holidaySelected(e)}
                    date={calanderDate}
                    onNavigate={(e) => { this.onNavigate(e) }}
                  />
                  <Dialog
                    open={isContentDialogOpen}
                  >
                    <DialogTitle>{editMode ? "Feiertag ändern" : "Feiertage hinzufügen"}</DialogTitle>
                    <DialogContent>
                      <div className="inner-field inner-field-1">
                        <label >Feiertag</label>
                        <TextField
                          inputProps={{
                            maxLength: 40
                          }}
                          style={{ maxWidth: 200 }} helperText={holidayTitleError ? "Please enter title for holiday" : ''} error={holidayTitleError ? true : false} autoFocus inputRef={this.textInput} size="small" value={holidayTitle} className="innerInput" onChange={(e) => this.holidayChangeHandler(e)} variant="outlined" />
                      </div>
                    </DialogContent>
                    <DialogActions>
                      {editMode ?
                        <Fragment>
                          <Button variant="outlined" color="primary" className="m-10" onClick={() => { this.editHoliday() }} >Speichern</Button>
                          <Button variant="outlined" color="primary" className="m-10" onClick={() => { this.openDeleteDialogPopup() }} >Löschen</Button>
                        </Fragment>
                        :
                        <Fragment>
                          <Button variant="outlined" color="primary" className="m-10" onClick={() => { this.addNewHoliday() }} >Speichern</Button>
                        </Fragment>
                      }
                      <Button onClick={this.closeContentDialog} variant="outlined" color="secondary"> Abbrechen </Button>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={isDeleteContactDialogOpen}
                  >
                    <DialogTitle>Feiertag löschen</DialogTitle>
                    <DialogContent>
                      <DialogContentText >
                        Sind Sie sicher?
              </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={this.deleteHoliday} size="small" variant="outlined" color="primary" autoFocus>
                        Bestätigen
              </Button>
                      <Button onClick={this.closeDeleteContactDialog} size="small" variant="outlined" color="secondary">
                        Abbrechen
              </Button>
                    </DialogActions>
                  </Dialog>

                  <Dialog
                    open={accessErrorDialog}
                  >
                    <DialogTitle>Einstufung</DialogTitle>
                    <DialogContent>
                      <DialogContentText >
                        {access_error && access_error.message}
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => this.setState({ accessErrorDialog: false })} size="small" variant="outlined" color="secondary" >
                        Abbrechen
              </Button>
                    </DialogActions>
                  </Dialog>
                </div>
              </Grid>
              :
              <Grid item md={12} sm={12} xs={12}>
                <div className="rightBlock rightBlock-bgWhite user-system">
                  <h3>{error.message}</h3>
                </div>
              </Grid>
            }
          </Grid>
        </Container>
      </div >
    )
  }
}

const mapStateToProps = ({ publicHoliday }) => {
  return {
    isloading: publicHoliday.loading,
    public_holidays: publicHoliday.public_holidays,
    error_validation: publicHoliday.error_message,
    access_error: publicHoliday.access_error,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetPublicHolidays: () => dispatch(GetPublicHolidays()),
    CreateHoliday: (date, name) => dispatch(CreateHoliday(date, name)),
    EditHoliday: (id, date, name) => dispatch(EditHoliday(id, date, name)),
    DeleteHoliday: (id) => dispatch(DeleteHoliday(id)),
    LogoutAction: () => dispatch(LogoutAction()),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(PublicHoliday)

class CustomToolbar extends Toolbar {
  render() {
    return (
      <div className='rbc-toolbar'>

        <span className="rbc-toolbar-label">{this.props.label}</span>
      </div>
    );
  }

}